import { FC } from "react";
import { CommandButtonGroup } from "@remirror/react-ui";
import {
  ToggleBoldButton,
  ToggleCodeButton,
  ToggleItalicButton,
  ToggleStrikeButton,
  ToggleUnderlineButton,
} from "./FormattingButtons";

interface FormattingButtonGroupProps {
  onBlur: () => void;
}

export const FormattingButtonGroup: FC<FormattingButtonGroupProps> = ({
  onBlur,
}: FormattingButtonGroupProps) => (
  <CommandButtonGroup>
    <ToggleBoldButton onBlur={onBlur} />
    <ToggleItalicButton onBlur={onBlur} />
    <ToggleUnderlineButton onBlur={onBlur} />
    <ToggleStrikeButton onBlur={onBlur} />
    <ToggleCodeButton onBlur={onBlur} />
  </CommandButtonGroup>
);
